import React, { Component } from "react";
import { Button } from "reactstrap";
import { Row, Col } from "reactstrap";
import JobDetails from "./jobDetails";
import "./style.css";
// import { Link } from "react-router-dom";
import Loader from "../../components/loader";
import ApplyVednor from "./applyVednor";

class Jobs extends Component {
  state = {
    activeJobs: [],
    selectedJob: null,
    loading: false,
  };

  componentDidMount = () => {
    this.setState({ loading: true });
    // fetch("http://localhost:5000/vendorProgram/all")
    fetch("https://work-web-server.herokuapp.com/vendorProgram/all")
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          let temp = [];
          // eslint-disable-next-line
          response.map((item) => {
            if (item.status === "active") {
              temp.push(item);
            }
          });

          this.setState({ activeJobs: temp, loading: false }, () => {
            console.log("Vendor Prg: ", this.state.activeJobs);
          });
        }
      });
  };

  render() {
    return (
      <div className="jobContainer">
        {this.state.loading ? (
          <Loader />
        ) : (
          <Row xs="1" sm="3" md="3">
            {this.state.activeJobs.map((item, index) => {
              return (
                <Col span={12}>
                  <div className="jobCard grow">
                    <div>
                      <h1 className="jobTitle tc">{item.programName}</h1>
                      <h3 className="jobDept">{item.country}</h3>
                    </div>
                    <hr className="my-2" />
                    <Row xs="3" sm="3" md="3" className="tc">
                      <Col>
                        <div className="jobDept tl">{item.titleLine}</div>
                      </Col>
                      <Col>
                        <p className="lead tc">
                          <JobDetails job={item} />
                        </p>
                      </Col>
                      <Col>
                        <ApplyVednor ClickedProgram={item} />
                        {/* <p className="lead tr">
                          <Link to="apply@w4work">
                            <Button
                              className="applyButtonProgram "
                              onClick={() => {
                                this.props.setSelectedJob(item);
                              }}
                            >
                              {" Apply Now ->"}
                            </Button>
                          </Link>
                        </p> */}
                      </Col>
                    </Row>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </div>
    );
  }
}

export default Jobs;
